"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = EncircledIcon;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
// Packages

function EncircledIcon({
  icon,
  width,
  height,
  title,
  circleColor,
  borderColor
}) {
  switch (icon) {
    default:
    case "bookmark":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Bookmark", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.3333 30.6667C22.6971 30.6667 28.6667 24.6971 28.6667 17.3333C28.6667 9.96954 22.6971 4 15.3333 4C7.96954 4 2 9.96954 2 17.3333C2 24.6971 7.96954 30.6667 15.3333 30.6667Z",
        fill: circleColor || "#FEF9EF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M21.6667 21L17 17.6667L12.3333 21V10.3333C12.3333 9.97971 12.4738 9.64057 12.7239 9.39052C12.9739 9.14048 13.3131 9 13.6667 9H20.3333C20.687 9 21.0261 9.14048 21.2762 9.39052C21.5262 9.64057 21.6667 9.97971 21.6667 10.3333V21Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "book-open":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Book Open", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.3333 30.6667C22.6971 30.6667 28.6667 24.6971 28.6667 17.3333C28.6667 9.96954 22.6971 4 15.3333 4C7.96954 4 2 9.96954 2 17.3333C2 24.6971 7.96954 30.6667 15.3333 30.6667Z",
        fill: circleColor || "#FEF9EF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10.3333 9H14.3333C15.0406 9 15.7189 9.28095 16.219 9.78105C16.7191 10.2811 17 10.9594 17 11.6667V21C17 20.4696 16.7893 19.9609 16.4142 19.5858C16.0392 19.2107 15.5304 19 15 19H10.3333V9Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M23.6667 9H19.6667C18.9594 9 18.2811 9.28095 17.781 9.78105C17.281 10.2811 17 10.9594 17 11.6667V21C17 20.4696 17.2107 19.9609 17.5858 19.5858C17.9609 19.2107 18.4696 19 19 19H23.6667V9Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "calendar":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Calendar", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.0333 30.6667C22.3971 30.6667 28.3667 24.6971 28.3667 17.3333C28.3667 9.96954 22.3971 4 15.0333 4C7.66953 4 1.7 9.96954 1.7 17.3333C1.7 24.6971 7.66953 30.6667 15.0333 30.6667Z",
        fill: circleColor || "#FEFCF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M21.6667 9.66663H12.3333C11.597 9.66663 11 10.2636 11 11V20.3333C11 21.0697 11.597 21.6666 12.3333 21.6666H21.6667C22.403 21.6666 23 21.0697 23 20.3333V11C23 10.2636 22.403 9.66663 21.6667 9.66663Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M19.6667 8.33337V11",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M14.3333 8.33337V11",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11 13.6666H23",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "check-circle":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Check Circle", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.3333 30.6667C22.6971 30.6667 28.6667 24.6971 28.6667 17.3333C28.6667 9.96954 22.6971 4 15.3333 4C7.96954 4 2 9.96954 2 17.3333C2 24.6971 7.96954 30.6667 15.3333 30.6667Z",
        fill: circleColor || "#F5FCFF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M23.6666 14.3867V15C23.6658 16.4376 23.2003 17.8365 22.3395 18.9879C21.4787 20.1393 20.2688 20.9817 18.8902 21.3893C17.5116 21.7969 16.0381 21.7479 14.6896 21.2497C13.3411 20.7515 12.1897 19.8307 11.4073 18.6247C10.6248 17.4187 10.2532 15.9921 10.3477 14.5576C10.4423 13.1231 10.9981 11.7576 11.9321 10.6647C12.8662 9.57189 14.1285 8.81027 15.5307 8.49344C16.933 8.17662 18.4001 8.32157 19.7133 8.90668",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M23.6667 9.66663L17 16.34L15 14.34",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "check":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Check", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.3333 30.6667C22.6971 30.6667 28.6667 24.6971 28.6667 17.3333C28.6667 9.96954 22.6971 4 15.3333 4C7.96954 4 2 9.96954 2 17.3333C2 24.6971 7.96954 30.6667 15.3333 30.6667Z",
        fill: circleColor || "#E8FAF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M23 10.5L14.75 18.75L11 15",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "dollar":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Dollar", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.3333 30.6667C22.6971 30.6667 28.6667 24.6971 28.6667 17.3333C28.6667 9.96954 22.6971 4 15.3333 4C7.96954 4 2 9.96954 2 17.3333C2 24.6971 7.96954 30.6667 15.3333 30.6667Z",
        fill: circleColor || "#E8FAF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17 5.83331V24.1666",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M21.1667 9.16669H14.9167C14.1431 9.16669 13.4013 9.47398 12.8543 10.021C12.3073 10.5679 12 11.3098 12 12.0834C12 12.8569 12.3073 13.5988 12.8543 14.1457C13.4013 14.6927 14.1431 15 14.9167 15H19.0833C19.8569 15 20.5987 15.3073 21.1457 15.8543C21.6927 16.4013 22 17.1431 22 17.9167C22 18.6902 21.6927 19.4321 21.1457 19.9791C20.5987 20.5261 19.8569 20.8334 19.0833 20.8334H12",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "file-arrow":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "File Arrow", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.0333 30.6667C22.3971 30.6667 28.3666 24.6971 28.3666 17.3333C28.3666 9.96954 22.3971 4 15.0333 4C7.66949 4 1.69995 9.96954 1.69995 17.3333C1.69995 24.6971 7.66949 30.6667 15.0333 30.6667Z",
        fill: circleColor || "#E8FAF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 8.33331H12C11.6463 8.33331 11.3072 8.47379 11.0572 8.72384C10.8071 8.97389 10.6666 9.31302 10.6666 9.66665V20.3333C10.6666 20.6869 10.8071 21.0261 11.0572 21.2761C11.3072 21.5262 11.6463 21.6666 12 21.6666H20C20.3536 21.6666 20.6927 21.5262 20.9428 21.2761C21.1928 21.0261 21.3333 20.6869 21.3333 20.3333V12.3333L17.3333 8.33331Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3334 8.33331V12.3333H21.3334",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M24.8435 15.8435C24.9411 15.7458 24.9411 15.5875 24.8435 15.4899L23.2525 13.8989C23.1549 13.8013 22.9966 13.8013 22.8989 13.8989C22.8013 13.9966 22.8013 14.1548 22.8989 14.2525L24.3132 15.6667L22.8989 17.0809C22.8013 17.1785 22.8013 17.3368 22.8989 17.4345C22.9966 17.5321 23.1549 17.5321 23.2525 17.4345L24.8435 15.8435ZM13.3334 15.4167C13.1953 15.4167 13.0834 15.5286 13.0834 15.6667C13.0834 15.8048 13.1953 15.9167 13.3334 15.9167V15.4167ZM24.6667 15.4167H13.3334V15.9167H24.6667V15.4167Z",
        fill: "#1A202C"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M18.6667 18.3333H13.3334",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M14.6667 13H14H13.3334",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "file":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "File", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.0333 30.6667C22.3971 30.6667 28.3666 24.6971 28.3666 17.3333C28.3666 9.96954 22.3971 4 15.0333 4C7.66949 4 1.69995 9.96954 1.69995 17.3333C1.69995 24.6971 7.66949 30.6667 15.0333 30.6667Z",
        fill: circleColor || "#FEFCF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M18.3333 8.33331H13C12.6463 8.33331 12.3072 8.47379 12.0572 8.72384C11.8071 8.97389 11.6666 9.31302 11.6666 9.66665V20.3333C11.6666 20.6869 11.8071 21.0261 12.0572 21.2761C12.3072 21.5262 12.6463 21.6666 13 21.6666H21C21.3536 21.6666 21.6927 21.5262 21.9428 21.2761C22.1928 21.0261 22.3333 20.6869 22.3333 20.3333V12.3333L18.3333 8.33331Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M18.3334 8.33331V12.3333H22.3334",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M19.6667 15.6667H14.3334",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M19.6667 18.3333H14.3334",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.6667 13H15H14.3334",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "flag":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Flag", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.3333 30.6667C22.6971 30.6667 28.6667 24.6971 28.6667 17.3333C28.6667 9.96954 22.6971 4 15.3333 4C7.96954 4 2 9.96954 2 17.3333C2 24.6971 7.96954 30.6667 15.3333 30.6667Z",
        fill: circleColor || "#FEFCF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11.6667 17C11.6667 17 12.3333 16.3333 14.3333 16.3333C16.3333 16.3333 17.6667 17.6666 19.6667 17.6666C21.6667 17.6666 22.3333 17 22.3333 17V8.99998C22.3333 8.99998 21.6667 9.66665 19.6667 9.66665C17.6667 9.66665 16.3333 8.33331 14.3333 8.33331C12.3333 8.33331 11.6667 8.99998 11.6667 8.99998V17Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.444444",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11.6667 21.6667V17",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.444444",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "folder":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Folder", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.3333 30.6667C22.6971 30.6667 28.6667 24.6971 28.6667 17.3333C28.6667 9.96954 22.6971 4 15.3333 4C7.96954 4 2 9.96954 2 17.3333C2 24.6971 7.96954 30.6667 15.3333 30.6667Z",
        fill: circleColor || "#F4EFFD"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M23.6667 19.6667C23.6667 20.0203 23.5262 20.3594 23.2762 20.6095C23.0261 20.8595 22.687 21 22.3333 21H11.6667C11.3131 21 10.9739 20.8595 10.7239 20.6095C10.4738 20.3594 10.3333 20.0203 10.3333 19.6667V10.3333C10.3333 9.97971 10.4738 9.64057 10.7239 9.39052C10.9739 9.14048 11.3131 9 11.6667 9H15L16.3333 11H22.3333C22.687 11 23.0261 11.1405 23.2762 11.3905C23.5262 11.6406 23.6667 11.9797 23.6667 12.3333V19.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "globe":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Globe", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.3333 30.6667C22.6971 30.6667 28.6667 24.6971 28.6667 17.3333C28.6667 9.96954 22.6971 4 15.3333 4C7.96954 4 2 9.96954 2 17.3333C2 24.6971 7.96954 30.6667 15.3333 30.6667Z",
        fill: circleColor || "#F5FCFF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17 21.6666C20.6819 21.6666 23.6666 18.6819 23.6666 15C23.6666 11.3181 20.6819 8.33331 17 8.33331C13.3181 8.33331 10.3333 11.3181 10.3333 15C10.3333 18.6819 13.3181 21.6666 17 21.6666Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10.3333 15H23.6666",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17 8.33331C18.6675 10.1589 19.6151 12.528 19.6666 15C19.6151 17.472 18.6675 19.8411 17 21.6666C15.3325 19.8411 14.3848 17.472 14.3333 15C14.3848 12.528 15.3325 10.1589 17 8.33331V8.33331Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "home":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Home", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.0333 30.6667C22.3971 30.6667 28.3667 24.6971 28.3667 17.3333C28.3667 9.96954 22.3971 4 15.0333 4C7.66955 4 1.70001 9.96954 1.70001 17.3333C1.70001 24.6971 7.66955 30.6667 15.0333 30.6667Z",
        fill: circleColor || "#FEF9EF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11 13L17 8.33331L23 13V20.3333C23 20.6869 22.8595 21.0261 22.6095 21.2761C22.3594 21.5262 22.0203 21.6666 21.6667 21.6666H12.3333C11.9797 21.6666 11.6406 21.5262 11.3905 21.2761C11.1405 21.0261 11 20.6869 11 20.3333V13Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15 21.6667V15H19V21.6667",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "info":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "info", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.3333 30.6667C22.6971 30.6667 28.6667 24.6971 28.6667 17.3333C28.6667 9.96954 22.6971 4 15.3333 4C7.96954 4 2 9.96954 2 17.3333C2 24.6971 7.96954 30.6667 15.3333 30.6667Z",
        fill: circleColor || "#E8FAF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17 21.6666C20.6819 21.6666 23.6667 18.6819 23.6667 15C23.6667 11.3181 20.6819 8.33331 17 8.33331C13.3181 8.33331 10.3333 11.3181 10.3333 15C10.3333 18.6819 13.3181 21.6666 17 21.6666Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17 17.6667V15",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17 12.3333H17.0075",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "layers":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Layers", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.3333 30.6667C22.6971 30.6667 28.6667 24.6971 28.6667 17.3333C28.6667 9.96954 22.6971 4 15.3333 4C7.96954 4 2 9.96954 2 17.3333C2 24.6971 7.96954 30.6667 15.3333 30.6667Z",
        fill: circleColor || "#E8FAF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17 8.33337L10.3333 11.6667L17 15L23.6667 11.6667L17 8.33337Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10.3333 18.3334L17 21.6667L23.6667 18.3334",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10.3333 15L17 18.3333L23.6667 15",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "light-bulb":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Light Bulb", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.0333 30.6667C22.3971 30.6667 28.3667 24.6971 28.3667 17.3333C28.3667 9.96954 22.3971 4 15.0333 4C7.66955 4 1.70001 9.96954 1.70001 17.3333C1.70001 24.6971 7.66955 30.6667 15.0333 30.6667Z",
        fill: circleColor || "#FEFCF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.0333 28.6667C24.3971 28.6667 30.3667 22.6971 30.3667 15.3333C30.3667 7.96954 24.3971 2 17.0333 2C9.66955 2 3.70001 7.96954 3.70001 15.3333C3.70001 22.6971 9.66955 28.6667 17.0333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.4692 17.0769V19.8461",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M14.2385 21.2308H20.7",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.1615 22.6154H19.7769",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M8.70001 14.7692H10.0846",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10.5461 9.23077L11.5252 10.2098",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M24.8539 14.7692H26.2385",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M23.4692 10.2098L24.4483 9.23077",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.4692 7.38458V5.99997",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.1575 19.8461C12.9914 18.941 11.4692 16.8021 11.4692 14.3077C11.4692 10.994 14.1555 8.30768 17.4692 8.30768C20.7829 8.30768 23.4692 10.994 23.4692 14.3077C23.4692 16.8021 21.9471 18.941 19.781 19.8461",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round"
      }));
    case "loading":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Loading", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.3333 30.6667C22.6971 30.6667 28.6667 24.6971 28.6667 17.3333C28.6667 9.96954 22.6971 4 15.3333 4C7.96954 4 2 9.96954 2 17.3333C2 24.6971 7.96954 30.6667 15.3333 30.6667Z",
        fill: circleColor || "#F5FCFF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17 8.33331V11",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.711111",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17 19V21.6667",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.711111",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12.2867 10.2867L14.1733 12.1733",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.711111",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M19.8267 17.8267L21.7133 19.7133",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.711111",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M10.3333 15H13",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.711111",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M21 15H23.6667",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.711111",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M12.2867 19.7133L14.1733 17.8267",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.711111",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M19.8267 12.1733L21.7133 10.2867",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.711111",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "mail":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Mail", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.0333 30.6667C22.3971 30.6667 28.3667 24.6971 28.3667 17.3333C28.3667 9.96954 22.3971 4 15.0333 4C7.66955 4 1.70001 9.96954 1.70001 17.3333C1.70001 24.6971 7.66955 30.6667 15.0333 30.6667Z",
        fill: circleColor || "#F4EFFD"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M11.6666 9.66669H22.3333C23.0666 9.66669 23.6666 10.2667 23.6666 11V19C23.6666 19.7334 23.0666 20.3334 22.3333 20.3334H11.6666C10.9333 20.3334 10.3333 19.7334 10.3333 19V11C10.3333 10.2667 10.9333 9.66669 11.6666 9.66669Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M23.6666 11L17 15.6667L10.3333 11",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "map-pin":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Map Pin", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.3333 30.6667C22.6971 30.6667 28.6667 24.6971 28.6667 17.3333C28.6667 9.96954 22.6971 4 15.3333 4C7.96954 4 2 9.96954 2 17.3333C2 24.6971 7.96954 30.6667 15.3333 30.6667Z",
        fill: circleColor || "#FEF9EF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M23 13.6667C23 18.3334 17 22.3334 17 22.3334C17 22.3334 11 18.3334 11 13.6667C11 12.0754 11.6321 10.5493 12.7574 9.42405C13.8826 8.29883 15.4087 7.66669 17 7.66669C18.5913 7.66669 20.1174 8.29883 21.2426 9.42405C22.3679 10.5493 23 12.0754 23 13.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17 15.6667C18.1046 15.6667 19 14.7713 19 13.6667C19 12.5621 18.1046 11.6667 17 11.6667C15.8954 11.6667 15 12.5621 15 13.6667C15 14.7713 15.8954 15.6667 17 15.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "megaphone":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Megaphone", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.0333 30.6667C22.3971 30.6667 28.3667 24.6971 28.3667 17.3333C28.3667 9.96954 22.3971 4 15.0333 4C7.66955 4 1.70001 9.96954 1.70001 17.3333C1.70001 24.6971 7.66955 30.6667 15.0333 30.6667Z",
        fill: circleColor || "#FEFCF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16.3333 28.6667C23.6971 28.6667 29.6667 22.6971 29.6667 15.3333C29.6667 7.96954 23.6971 2 16.3333 2C8.96954 2 3 7.96954 3 15.3333C3 22.6971 8.96954 28.6667 16.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M22.2814 8.43622C22.2814 8.05889 21.8449 7.84911 21.5503 8.08483L17.471 11.3482H10.4C9.90297 11.3482 9.50003 11.7512 9.50003 12.2482V16.2206C9.50003 16.7177 9.90297 17.1206 10.4 17.1206H17.471L21.5503 20.384C21.8449 20.6197 22.2814 20.41 22.2814 20.0326V8.43622Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M9.79999 16.8V22.0992H12.5485L11.93 16.8",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M22.3491 12.0706C22.9332 12.0706 24.2 12.6547 24.2 14.4438C24.2 16.2328 22.9332 16.743 22.3491 16.743",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "message-send":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Send Message", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.0333 30.6667C22.3971 30.6667 28.3667 24.6971 28.3667 17.3333C28.3667 9.96954 22.3971 4 15.0333 4C7.66955 4 1.70001 9.96954 1.70001 17.3333C1.70001 24.6971 7.66955 30.6667 15.0333 30.6667Z",
        fill: circleColor || "#F5FCFF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M23.6666 8.33331L16.3333 15.6666",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M23.6666 8.33331L19 21.6666L16.3333 15.6666L10.3333 13L23.6666 8.33331Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "message":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Message", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.0333 30.6667C22.3971 30.6667 28.3667 24.6971 28.3667 17.3333C28.3667 9.96954 22.3971 4 15.0333 4C7.66955 4 1.70001 9.96954 1.70001 17.3333C1.70001 24.6971 7.66955 30.6667 15.0333 30.6667Z",
        fill: circleColor || "#FEFCF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.0333 28.6667C24.3971 28.6667 30.3667 22.6971 30.3667 15.3333C30.3667 7.96954 24.3971 2 17.0333 2C9.66955 2 3.70001 7.96954 3.70001 15.3333C3.70001 22.6971 9.66955 28.6667 17.0333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M23.7 17C23.7 17.3536 23.5595 17.6928 23.3095 17.9428C23.0594 18.1929 22.7203 18.3333 22.3667 18.3333H14.3667L11.7 21V10.3333C11.7 9.97971 11.8405 9.64057 12.0905 9.39052C12.3406 9.14048 12.6797 9 13.0333 9H22.3667C22.7203 9 23.0594 9.14048 23.3095 9.39052C23.5595 9.64057 23.7 9.97971 23.7 10.3333V17Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "mobile":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Mobile", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.0333 30.6667C22.3971 30.6667 28.3667 24.6971 28.3667 17.3333C28.3667 9.96954 22.3971 4 15.0333 4C7.66955 4 1.70001 9.96954 1.70001 17.3333C1.70001 24.6971 7.66955 30.6667 15.0333 30.6667Z",
        fill: circleColor || "#E8FAF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M20.3333 8.33331H13.6666C12.9303 8.33331 12.3333 8.93027 12.3333 9.66665V20.3333C12.3333 21.0697 12.9303 21.6666 13.6666 21.6666H20.3333C21.0697 21.6666 21.6666 21.0697 21.6666 20.3333V9.66665C21.6666 8.93027 21.0697 8.33331 20.3333 8.33331Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17 19H17.0075",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "pause":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Pause", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.0333 30.6667C22.3971 30.6667 28.3667 24.6971 28.3667 17.3333C28.3667 9.96954 22.3971 4 15.0333 4C7.66955 4 1.70001 9.96954 1.70001 17.3333C1.70001 24.6971 7.66955 30.6667 15.0333 30.6667Z",
        fill: circleColor || "#FEF9EF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.6667 9.66669H13V20.3334H15.6667V9.66669Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M21 9.66669H18.3333V20.3334H21V9.66669Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "phone":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Phone", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.0333 30.6667C22.3971 30.6667 28.3667 24.6971 28.3667 17.3333C28.3667 9.96954 22.3971 4 15.0333 4C7.66955 4 1.70001 9.96954 1.70001 17.3333C1.70001 24.6971 7.66955 30.6667 15.0333 30.6667Z",
        fill: circleColor || "#F5FCFF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M23.2587 17.9467V19.9467C23.2595 20.1324 23.2215 20.3162 23.1471 20.4863C23.0727 20.6564 22.9636 20.8091 22.8268 20.9346C22.69 21.0602 22.5285 21.1557 22.3526 21.2152C22.1767 21.2747 21.9903 21.2968 21.8054 21.2801C19.754 21.0572 17.7834 20.3562 16.0521 19.2334C14.4413 18.2098 13.0756 16.8442 12.0521 15.2334C10.9254 13.4942 10.2242 11.5141 10.0054 9.4534C9.98875 9.26904 10.0107 9.08324 10.0697 8.90781C10.1288 8.73239 10.2238 8.57119 10.3486 8.43448C10.4734 8.29777 10.6253 8.18854 10.7946 8.11375C10.9639 8.03895 11.147 8.00024 11.3321 8.00006H13.3321C13.6556 7.99688 13.9693 8.11145 14.2146 8.32242C14.4599 8.53339 14.6201 8.82636 14.6654 9.14673C14.7498 9.78678 14.9064 10.4152 15.1321 11.0201C15.2218 11.2587 15.2412 11.518 15.188 11.7673C15.1348 12.0166 15.0113 12.2455 14.8321 12.4267L13.9854 13.2734C14.9344 14.9424 16.3164 16.3244 17.9854 17.2734L18.8321 16.4267C19.0133 16.2475 19.2422 16.124 19.4915 16.0708C19.7408 16.0176 20.0001 16.037 20.2387 16.1267C20.8436 16.3524 21.472 16.509 22.1121 16.5934C22.4359 16.6391 22.7317 16.8022 22.9431 17.0517C23.1545 17.3013 23.2669 17.6198 23.2587 17.9467Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "search":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Search", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.3333 30.6667C22.6971 30.6667 28.6667 24.6971 28.6667 17.3333C28.6667 9.96954 22.6971 4 15.3333 4C7.96954 4 2 9.96954 2 17.3333C2 24.6971 7.96954 30.6667 15.3333 30.6667Z",
        fill: circleColor || "#FEF9EF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M16.3333 19.6667C19.2789 19.6667 21.6667 17.2789 21.6667 14.3333C21.6667 11.3878 19.2789 9 16.3333 9C13.3878 9 11 11.3878 11 14.3333C11 17.2789 13.3878 19.6667 16.3333 19.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.444444",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M23 21L20.1 18.1",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.444444",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "star":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Star", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.0333 30.6667C22.3971 30.6667 28.3667 24.6971 28.3667 17.3333C28.3667 9.96954 22.3971 4 15.0333 4C7.66955 4 1.70001 9.96954 1.70001 17.3333C1.70001 24.6971 7.66955 30.6667 15.0333 30.6667Z",
        fill: circleColor || "#E8FAF6"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.0333 28.6667C24.3971 28.6667 30.3667 22.6971 30.3667 15.3333C30.3667 7.96954 24.3971 2 17.0333 2C9.66955 2 3.70001 7.96954 3.70001 15.3333C3.70001 22.6971 9.66955 28.6667 17.0333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17 8.33331L19.06 12.5066L23.6666 13.18L20.3333 16.4266L21.12 21.0133L17 18.8466L12.88 21.0133L13.6666 16.4266L10.3333 13.18L14.94 12.5066L17 8.33331Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "trend-up":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Trend Up", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.3333 30.6667C22.6971 30.6667 28.6667 24.6971 28.6667 17.3333C28.6667 9.96954 22.6971 4 15.3333 4C7.96954 4 2 9.96954 2 17.3333C2 24.6971 7.96954 30.6667 15.3333 30.6667Z",
        fill: circleColor || "#F4EFFD"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M25.25 10.5L18.125 17.625L14.375 13.875L8.75 19.5",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M20.75 10.5H25.25V15",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "users":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Users", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.3333 30.6667C22.6971 30.6667 28.6667 24.6971 28.6667 17.3333C28.6667 9.96954 22.6971 4 15.3333 4C7.96954 4 2 9.96954 2 17.3333C2 24.6971 7.96954 30.6667 15.3333 30.6667Z",
        fill: circleColor || "#FEF9EF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M20.75 21.75V20.25C20.75 19.4544 20.4339 18.6913 19.8713 18.1287C19.3087 17.5661 18.5456 17.25 17.75 17.25H11.75C10.9544 17.25 10.1913 17.5661 9.62868 18.1287C9.06607 18.6913 8.75 19.4544 8.75 20.25V21.75",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M14.75 14.25C16.4069 14.25 17.75 12.9069 17.75 11.25C17.75 9.59315 16.4069 8.25 14.75 8.25C13.0931 8.25 11.75 9.59315 11.75 11.25C11.75 12.9069 13.0931 14.25 14.75 14.25Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M25.25 21.75V20.25C25.2495 19.5853 25.0283 18.9396 24.621 18.4143C24.2138 17.8889 23.6436 17.5137 23 17.3475",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M20 8.34753C20.6453 8.51276 21.2173 8.88806 21.6257 9.41427C22.0342 9.94047 22.2559 10.5877 22.2559 11.2538C22.2559 11.9199 22.0342 12.5671 21.6257 13.0933C21.2173 13.6195 20.6453 13.9948 20 14.16",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "write":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Write", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.0333 30.6667C22.3971 30.6667 28.3667 24.6971 28.3667 17.3333C28.3667 9.96954 22.3971 4 15.0333 4C7.66955 4 1.70001 9.96954 1.70001 17.3333C1.70001 24.6971 7.66955 30.6667 15.0333 30.6667Z",
        fill: circleColor || "#FEF9EF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17 20.3333H23",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M20 9.33334C20.2652 9.06813 20.6249 8.91913 21 8.91913C21.1857 8.91913 21.3696 8.95571 21.5412 9.02678C21.7128 9.09785 21.8687 9.20202 22 9.33334C22.1313 9.46466 22.2355 9.62057 22.3066 9.79215C22.3776 9.96373 22.4142 10.1476 22.4142 10.3333C22.4142 10.5191 22.3776 10.703 22.3066 10.8745C22.2355 11.0461 22.1313 11.202 22 11.3333L13.6667 19.6667L11 20.3333L11.6667 17.6667L20 9.33334Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
    case "x-close":
      return /*#__PURE__*/_react.default.createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, title || "Close", /*#__PURE__*/_react.default.createElement("path", {
        d: "M15.3333 30.6667C22.6971 30.6667 28.6667 24.6971 28.6667 17.3333C28.6667 9.96954 22.6971 4 15.3333 4C7.96954 4 2 9.96954 2 17.3333C2 24.6971 7.96954 30.6667 15.3333 30.6667Z",
        fill: circleColor || "#F5FCFF"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M17.3333 28.6667C24.6971 28.6667 30.6667 22.6971 30.6667 15.3333C30.6667 7.96954 24.6971 2 17.3333 2C9.96954 2 4 7.96954 4 15.3333C4 22.6971 9.96954 28.6667 17.3333 28.6667Z",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M21 11L13 19",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }), /*#__PURE__*/_react.default.createElement("path", {
        d: "M13 11L21 19",
        stroke: borderColor || "#1A202C",
        strokeWidth: "0.8",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }));
  }
}
EncircledIcon.propTypes = {
  /**
   * Name of icon
   */
  icon: _propTypes.default.string.isRequired,
  /**
   * Sets width of icon
   */
  width: _propTypes.default.number,
  /**
   * Sets height of icon
   */
  height: _propTypes.default.number,
  /**
   * Sets color of circle (bottom circle)
   */
  circleColor: _propTypes.default.string,
  /**
   * Sets color of circle and icon border
   */
  borderColor: _propTypes.default.string,
  /**
   * Sets title of icon for accessibility
   */
  title: _propTypes.default.string
};
EncircledIcon.defaultProps = {
  height: 32,
  width: 32,
  circleColor: "#f5fcff",
  borderColor: "#1a202c"
};
EncircledIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EncircledIcon",
  "props": {
    "height": {
      "defaultValue": {
        "value": "32",
        "computed": false
      },
      "description": "Sets height of icon",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "width": {
      "defaultValue": {
        "value": "32",
        "computed": false
      },
      "description": "Sets width of icon",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "circleColor": {
      "defaultValue": {
        "value": "\"#f5fcff\"",
        "computed": false
      },
      "description": "Sets color of circle (bottom circle)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "borderColor": {
      "defaultValue": {
        "value": "\"#1a202c\"",
        "computed": false
      },
      "description": "Sets color of circle and icon border",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "icon": {
      "description": "Name of icon",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "title": {
      "description": "Sets title of icon for accessibility",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};